// extracted by mini-css-extract-plugin
module.exports = {"h1":"Htag_h1__tr4lo","h2":"Htag_h2__l6lkI","h3":"Htag_h3__F1VEH"};